/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function CreateTableTagRelationRequestFromJSON(json) {
    return CreateTableTagRelationRequestFromJSONTyped(json, false);
}
export function CreateTableTagRelationRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        name: json['name'],
        description: json['description'],
        tableTagId: json['tableTagId'],
        connectedTableTagId: json['connectedTableTagId'],
    };
}
export function CreateTableTagRelationRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        name: value.name,
        description: value.description,
        tableTagId: value.tableTagId,
        connectedTableTagId: value.connectedTableTagId,
    };
}
